import React from 'react';
import { Row } from 'react-bootstrap';
import { FormNumber, Fieldset } from '~/components/FormControl';

function HealthPoint() {
    return (
        <Fieldset className={'px-4'}>
            <Fieldset.Legend>HP:</Fieldset.Legend>
            <Row>
                <FormNumber
                    name="addonMaxHp"
                    isNegativeAllowed
                    sm={6}
                />
                <FormNumber
                    name="addonRegenHp"
                    isNegativeAllowed
                    sm={6}
                />
            </Row>
        </Fieldset>
    );
}

export default HealthPoint;
